import splide from '@splidejs/splide';
import sliderConfig from './splide.js';
import store from '../store';
import uuid from '../uuid';
import '../s2s';
import { getCustomerUuid } from '../common';

window.store = store;

require('../cookie-policy');

export const app = {
  dom: {
    stories: '.js--stories-slider',
    quotes: {
      controls: '.js--quotes-controls-slider',
      display: '.js--quotes-display-slider',
    },
  },
  setAppObj() {
    const { dom } = this;
    const { stories, quotes } = sliderConfig;

    window.app = {
      setModalDisplay: this.setModalDisplay,
      sliders: {
        stories: new splide(dom.stories, stories),
        quotesControls: new splide(dom.quotes.controls, quotes.controls),
        quotesDisplay: new splide(dom.quotes.display, quotes.display),
      },
    };
  },
  setModalDisplay(slug, event, set = false) {
    event.preventDefault();

    const el = document.querySelector(`[data-diet-modal=${slug}]`);

    el.classList[set ? 'add' : 'remove']('opacity-1 pointer-events-auto');
  },
  mountSliders() {
    let { stories, quotesControls, quotesDisplay } = window.app.sliders;

    stories.mount();

    quotesControls.mount().on('click', slide => {
      quotesControls.go(slide.index);
    });

    quotesDisplay.sync(quotesControls).mount();
  },
  init() {
    store.storeMarketingInfo();
    this.setCardsHref();
    if (document.getElementsByClassName('js--stories-slider').length) {
      this.setAppObj();
      this.mountSliders();
    }
  },
  setCardsHref() {
    const customerId = getCustomerUuid() || uuid.v4();
    const dietCards = document.querySelectorAll('.js-diet-card');
    const currentLocationQueryParams = new URLSearchParams(window.location.search);

    store.storeCustomerUuid(customerId);

    dietCards.forEach(card => {
      const cardUrl = new URL(card.href);
      const cardQueryParams = new URLSearchParams(cardUrl.searchParams);

      cardQueryParams.append('cid', customerId);
      currentLocationQueryParams.forEach((value, key) => cardQueryParams.append(key, value));
      cardUrl.search = cardQueryParams.toString();
      card.href = cardUrl.toString();
    });
  },
};

document.addEventListener('DOMContentLoaded', () => {
  app.init();
});
